import { useState } from 'react'
import Text from '../../../../../core/utils/Text'
import MotionFade from '../../../../common/utils/MotionFade'
import {
	useGetConfigItems,
	useSetConfigItems,
} from '../../../../../core/services/react-query/setting'
import { useEffect } from 'react'
import { ClipLoader } from 'react-spinners'

const AuthenticationSetting = () => {
	const authTypes = ['manual', 'uid', 'sumsub']
	const [authType, setAuthType] = useState('')

	const { data: configs } = useGetConfigItems()
	const { mutate: setConfigs, isLoading } = useSetConfigItems()
	useEffect(() => {
		if (!!configs) setAuthType(configs.kycType)
	}, [configs])

	const onChangeKycType = () => {
		setConfigs({
			data: {
				...configs,
				kycType: authType,
			},
		})
	}

	return (
		<MotionFade>
			<div className={'flex flex-col gap-5 dark:text-white p-3'}>
				<Text tid={'select-auth-type'} />
				<div className={'flex justify-center flex-col gap-3'}>
					{authTypes.map((t) => {
						const active = t === authType
						return (
							<div
								key={t}
								onClick={() => setAuthType(t)}
								className={'flex items-center gap-2 cursor-pointer text-sm'}
							>
								<div
									className={`${
										active ? 'border-green-500' : 'border-gray-500'
									} border-[2px] w-[22px] h-[22px] rounded-[50%] flex items-center justify-center `}
								>
									{active ? (
										<div className={'w-[14px] h-[14px] rounded-[50%] bg-green-500'} />
									) : null}
								</div>
								<Text
									tid={`${t}-auth`}
									className={active ? 'text-green-500' : 'dark:text-gray-300'}
								/>
							</div>
						)
					})}
				</div>

				{configs?.kycType !== authType ? (
					<div
						onClick={onChangeKycType}
						className={
							'bg-active mt-5 cursor-pointer text-gray-800 h-[42px] w-[240px] text-sm flex items-center justify-center rounded-md transition'
						}
					>
						{isLoading ? <ClipLoader size={18} /> : <Text tid={'submit'} />}
					</div>
				) : null}
			</div>
		</MotionFade>
	)
}

export default AuthenticationSetting
